'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _reactIntl = require('react-intl');

var _components = require('./../../components');

var _DefaultString = require('../../helpers/DefaultString');

var _Language = require('../../helpers/Language');

var _auth = require('../../redux/modules/auth');

var _QRSteps = require('./QRSteps.scss');

var _QRSteps2 = _interopRequireDefault(_QRSteps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var gear = require('../../../res/images/qrSteps/login_gear.png');
var step1 = require('../../../res/images/qrSteps/login_step_1.png');
var step2 = require('../../../res/images/qrSteps/login_step_2.png');

var QRSteps = (_dec = (0, _reactRedux.connect)(function (state) {
  return { auth: state.auth, lang: state.auth.lang, sessionId: state.auth.sessionId };
}, { login: _auth.login, pushState: _reactRouterRedux.push }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(QRSteps, _Component);

  function QRSteps() {
    (0, _classCallCheck3.default)(this, QRSteps);
    return (0, _possibleConstructorReturn3.default)(this, (QRSteps.__proto__ || (0, _getPrototypeOf2.default)(QRSteps)).apply(this, arguments));
  }

  (0, _createClass3.default)(QRSteps, [{
    key: 'render',
    value: function render() {
      var appleStoreImg = (0, _Language.translateResource)(this.props.lang, _Language.resources.AppleStore);
      var googleStoreImg = (0, _Language.translateResource)(this.props.lang, _Language.resources.GoogleStore);

      var hasBadges = this.props.hasBadges;


      return _react2.default.createElement(
        'div',
        { className: _QRSteps2.default.qrSteps },
        _react2.default.createElement(
          'div',
          { className: _QRSteps2.default.qrStepsContent },
          _react2.default.createElement(
            'div',
            { className: _QRSteps2.default.step },
            _react2.default.createElement(
              _reactAddonsCssTransitionGroup2.default,
              {
                className: _QRSteps2.default.cssAnimation,
                transitionName: 'fadeInStep1',
                transitionAppear: true,
                transitionAppearTimeout: 300,
                transitionEnter: false,
                transitionLeave: false
              },
              _react2.default.createElement(
                'span',
                { className: _QRSteps2.default.number },
                '1'
              ),
              _react2.default.createElement('img', { className: _QRSteps2.default.stepImage1, src: step1 }),
              _react2.default.createElement(
                'div',
                { className: _QRSteps2.default.stepTitle },
                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, this.props.step1StingId)
              ),
              hasBadges ? _react2.default.createElement(
                'div',
                { className: _QRSteps2.default.badges },
                _react2.default.createElement('img', { className: _QRSteps2.default.badge + ' ' + _QRSteps2.default.playBadge, src: googleStoreImg }),
                _react2.default.createElement('img', { className: _QRSteps2.default.badge, src: appleStoreImg })
              ) : ''
            )
          ),
          _react2.default.createElement(
            'div',
            { className: _QRSteps2.default.step },
            _react2.default.createElement(
              _reactAddonsCssTransitionGroup2.default,
              {
                className: _QRSteps2.default.cssAnimation,
                transitionName: 'fadeInStep2',
                transitionAppear: true,
                transitionAppearTimeout: 500,
                transitionEnter: false,
                transitionLeave: false
              },
              _react2.default.createElement(
                'span',
                { className: _QRSteps2.default.number },
                '2'
              ),
              _react2.default.createElement('img', { className: _QRSteps2.default.stepImage2, src: step2 }),
              _react2.default.createElement(
                'div',
                { className: _QRSteps2.default.stepTitle },
                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, _DefaultString.translations.QRLoginStep2Part1),
                _react2.default.createElement('img', { className: _QRSteps2.default.gear, src: gear }),
                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, _DefaultString.translations.QRLoginStep2Part2)
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: _QRSteps2.default.step },
            _react2.default.createElement(
              _reactAddonsCssTransitionGroup2.default,
              {
                className: _QRSteps2.default.cssAnimation,
                transitionName: 'fadeInStep3',
                transitionAppear: true,
                transitionAppearTimeout: 700,
                transitionEnter: false,
                transitionLeave: false
              },
              _react2.default.createElement(
                'span',
                { className: _QRSteps2.default.number },
                '3'
              ),
              _react2.default.createElement(_components.QRCode, { className: _QRSteps2.default.qrCode }),
              _react2.default.createElement(
                'div',
                { className: _QRSteps2.default.stepTitle },
                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, _DefaultString.translations.QRLoginStep3)
              )
            )
          )
        )
      );
    }
  }]);
  return QRSteps;
}(_react.Component), _class2.propTypes = {
  lang: _react.PropTypes.string,
  hasBadges: _react.PropTypes.bool,
  step1StingId: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = QRSteps;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/QRSteps/QRSteps.js
// module id = 1984
// module chunks = 0